// De zoekcriteria van een filtervoorstel, en de vertaling ervan naar InstantSearch.
// Gedeeld door de zoekchat (/search) en de workspace. De backend heeft een
// spiegel hiervan in ca_project/project/chat_filters.py -- die bewaart het
// filter, deze past het toe.

import { config } from "../state/config";

const ZONE_KEYS = ["zone_1", "zone_2"];

// Afgeleid uit settings.FACETS (via de context processor): een nieuw facet werkt
// zo vanzelf mee, in plaats van stilzwijgend weg te vallen omdat een lijst hier
// niet is bijgewerkt.
const categoricalKeys = Object.keys(config.facets.category ?? {}).filter(
  (key) => !ZONE_KEYS.includes(key)
);
const rangeKeys = Object.keys(config.facets.range ?? {});

export function toIndexUiState(filters: Record<string, any>) {
  const refinementList: Record<string, string[]> = {};
  const range: Record<string, string> = {};
  const hierarchicalMenu: Record<string, string[]> = {};

  const zone1 = filters.zone_1;
  const zone2 = filters.zone_2;
  if (zone2 && typeof zone2 === "string") {
    hierarchicalMenu["zone_1"] = [zone1 ?? zone2, zone2];
  } else if (zone1 && typeof zone1 === "string") {
    hierarchicalMenu["zone_1"] = [zone1];
  }

  for (const [key, value] of Object.entries(filters)) {
    if (ZONE_KEYS.includes(key)) continue;
    if (categoricalKeys.includes(key) && Array.isArray(value)) {
      refinementList[key] = value;
    } else if (rangeKeys.includes(key) && typeof value === "object" && value !== null) {
      const min = value.min ?? "";
      const max = value.max ?? "";
      range[key] = `${min}:${max}`;
    }
  }

  return { refinementList, range, hierarchicalMenu };
}
